import { Box, CircularProgress, Stack } from '@mui/material';
import { BrandIconWordMark } from '../top-nav-bar/components/BrandIcon';

export function Loading({
  showIcon,
  size = '10vh',
}: {
  showIcon?: boolean;
  size?: string;
}) {
  return (
    <Stack
      direction="column"
      height="100%"
      width="100%"
      top="50vh"
      left="50vw"
      alignItems="center"
      justifyContent="center"
      border="none"
    >
      <Box>
        <CircularProgress size={size} />
      </Box>
      {showIcon && (
        <Box>
          <BrandIconWordMark />
        </Box>
      )}
    </Stack>
  );
}
